import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { DashboardApi } from '../../../services';
import { WaterTestFormState } from '../waterTestForm.slice';

export const submitWaterTestFormAsync = createAsyncThunk(
  'waterTestForm/submit',
  async ( _, { getState, rejectWithValue }) => {
    try {
      const { waterTestForm } = getState() as { waterTestForm: WaterTestFormState }
      const formData = {
        ...waterTestForm.formData,
        waterSourceType: waterTestForm.formData.waterSource === 'well' 
          ? 'WELL_WATER_SYSTEM' 
          : 'PUBLIC_WATER_SYSTEM'
      }

      const response = await DashboardApi.submitWaterTestStripRequest(formData);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || {
          message: "Unexpected error occurred",
          errors: []
        }
      );
    }
  }
);

export const submitWaterTestFormAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterTestFormState>
) => {
  builder.addCase(submitWaterTestFormAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = null;
  })
  builder.addCase(
    submitWaterTestFormAsync.fulfilled,
    (state) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.isSubmitted = true;
    }
  )
  builder.addCase(
    submitWaterTestFormAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  )
}